import { render, staticRenderFns } from "./userId.vue?vue&type=template&id=40b099a6&scoped=true&lang=pug&"
import script from "./userId.vue?vue&type=script&lang=js&"
export * from "./userId.vue?vue&type=script&lang=js&"
import style0 from "./userId.vue?vue&type=style&index=0&id=40b099a6&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40b099a6",
  null
  
)

export default component.exports